import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'statusDropdown'];

  connect() {
    const form = this.hasFormTarget ? this.formTarget : this.element;
    const formInputs = form.querySelectorAll('input');

    this._onInputChange = this.saveData.bind(this);
    formInputs.forEach((e) => e.addEventListener('change', this._onInputChange));
  }

  showSaveStatus() {
    $('#overview-save-status').find('i').removeClass('tw-hidden');
    $('#overview-save-status').find('span').removeClass('tw-hidden');
  }

  saveData() {
    const $this = this;
    if (!$this.hasFormTarget) {
      console.error('No form target found.');
      return;
    }

    const form = $this.formTarget;
    $this.showSaveStatus();

    clearTimeout($this._t);
    $this._t = setTimeout(() => {
      form.requestSubmit();
    }, 3000);
  }

  closeDropdown(e) {
    if (!this.hasStatusDropdownTarget) return;

    const dropdown = this.statusDropdownTarget;
    const toggle = dropdown.querySelector('[data-toggle="dropdown"]');

    const clickedText = e.currentTarget.textContent.trim();
    const labelSpan = toggle?.querySelector('span');
    if (labelSpan && clickedText) labelSpan.textContent = clickedText;

    dropdown.classList.remove('open');
    toggle?.setAttribute('aria-expanded', 'false');
  }

  disconnect() {
    const form = this.hasFormTarget ? this.formTarget : this.element;
    const formInputs = form.querySelectorAll('input');

    formInputs.forEach((e) => e.removeEventListener('change', this._onInputChange));
  }
}
